import React from "react";
import Markdown from 'react-markdown';

function SurveyAssistantMessageText(props) {
    let {text} = props;

    return (
        <>
            <Markdown>
                {text}
            </Markdown>
        </>
    );
}

export default SurveyAssistantMessageText;